import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faGoogle, faUps } from '@fortawesome/free-brands-svg-icons'
import {
  faAddressBook,
  faAnalytics,
  faAngleDown,
  faAngleUp,
  faArchive,
  faArrowDown,
  faArrowDown19,
  faArrowDownAZ,
  faArrowDownToLine,
  faArrowLeft,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRotateRight,
  faArrowsAltV,
  faArrowsFromLine,
  faArrowsUpDown,
  faArrowToLeft,
  faArrowToRight,
  faArrowTurnDownRight,
  faArrowUp,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faAt,
  faBackspace,
  faBadgeCheck,
  faBadgeDollar,
  faBallotCheck,
  faBan,
  faBars,
  faBell,
  faBellOn,
  faBellSlash,
  faBook,
  faBox,
  faBoxes,
  faBroadcastTower,
  faBug,
  faBuilding,
  faBullseyeArrow,
  faCalculator,
  faCalendar,
  faCalendarAlt,
  faCalendarDay,
  faCaretCircleDown,
  faCaretCircleUp,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleMinus,
  faCity,
  faClipboard,
  faClock,
  faClone,
  faCloudDownload,
  faCloudUpload,
  faCloudUploadAlt,
  faCode,
  faCog,
  faColumns3,
  faCommentAlt,
  faCommentAltDollar,
  faCommentAltDots,
  faCommentAltLines,
  faCommentAltMinus,
  faCommentAltSlash,
  faCreditCardBlank,
  faCrown,
  faDash,
  faDollarSign,
  faDolly,
  faDonate,
  faDotCircle,
  faDownload,
  faEdit,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faEnvelopeOpen,
  faEnvelopes,
  faEraser,
  faExchange,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFemale,
  faFile,
  faFileAlt,
  faFileContract,
  faFileExport,
  faFileInvoiceDollar,
  faFileMinus,
  faFilePdf,
  faFilePlus,
  faFilter,
  faFlask,
  faForklift,
  faGasPump,
  faGlobe,
  faGlobeAmericas,
  faGripDots,
  faHammer,
  faHandPaper,
  faHandPointer,
  faHashtag,
  faHistory,
  faHome,
  faIdCardAlt,
  faIndustryAlt,
  faInfoCircle,
  faKey,
  faLayerGroup,
  faLightbulb,
  faLink,
  faList,
  faListUl,
  faLocationArrow,
  faLock,
  faMale,
  faMapMarker,
  faMapSigns,
  faMarker,
  faMaximize,
  faMerge,
  faMessageDots,
  faMessages,
  faMicrochipAi,
  faMinimize,
  faMinus,
  faMoneyCheckAlt,
  faMoneyCheckEditAlt,
  faPaintBrush,
  faPaperPlane,
  faPen,
  faPenAlt,
  faPercent,
  faPhone,
  faPlus,
  faPowerOff,
  faPrint,
  faQuestionCircle,
  faQuoteLeft,
  faRadiationAlt,
  faRampLoading,
  faRandom,
  faRectangleList,
  faRedo,
  faRepeatAlt,
  faRoad,
  faRocketLaunch,
  faRoute,
  faRouteInterstate,
  faRuler,
  faSaltShaker,
  faSave,
  faScaleBalanced,
  faSearch,
  faServer,
  faShare,
  faShieldCheck,
  faShippingFast,
  faShippingTimed,
  faSolarSystem,
  faSortAlt,
  faSortCircleUp,
  faSpinner,
  faSquare,
  faSquareArrowDown,
  faSquareArrowUp,
  faSquareArrowUpRight,
  faSquareFull,
  faSquareMinus,
  faStarSharp,
  faStepForward,
  faStickyNote,
  faStopwatch,
  faStoreAlt,
  faSync,
  faTable,
  faTags,
  faTally,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faThumbtackAngle,
  faTicket,
  faTimes,
  faToggleOn,
  faToiletPaperUnder,
  faTrash,
  faTrashRestoreAlt,
  faTrashXmark,
  faTree,
  faTriangle,
  faTrophy,
  faTruck,
  faTruckFast,
  faTruckMoving,
  faTruckRampBox,
  faUndo,
  faUnlock,
  faUpload,
  faUsdCircle,
  faUsdSquare,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserRobot,
  faUserShield,
  faUsers,
  faWarehouse,
  faWarehouseAlt,
  faWeightHanging,
  faWindowMinimize,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons'
import { faCircle as faCircleSolid } from '@fortawesome/pro-solid-svg-icons'
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'
import {
  faCircleCheck as faCircleCheckSharpDuotone,
  faCircleDot as faCircleDotSharpDuotone,
  faTriangleExclamation as faTriangleExclamationSharpDuotone,
} from '@fortawesome/sharp-duotone-regular-svg-icons'
import clsx from 'clsx'
import { type ForwardedRef, forwardRef, memo } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

import { faPalletJack } from './custom-icons'

const faIcons = {
  'address-book': faAddressBook,
  'angle-down': faAngleDown,
  'angle-up': faAngleUp,
  'arrow-down': faArrowDown,
  'arrow-down-1-9': faArrowDown19,
  'arrow-down-a-z': faArrowDownAZ,
  'arrow-down-to-line': faArrowDownToLine,
  'arrow-turn-down-right': faArrowTurnDownRight,
  'arrow-left': faArrowLeft,
  'arrow-right': faArrowRight,
  'arrow-rotate-right': faArrowRotateRight,
  'arrow-right-from-bracket': faArrowRightFromBracket,
  'arrow-up': faArrowUp,
  'arrow-to-left': faArrowToLeft,
  'arrow-to-right': faArrowToRight,
  'arrows-alt-v': faArrowsAltV,
  'arrows-from-line': faArrowsFromLine,
  'arrows-up-down': faArrowsUpDown,
  'badge-check': faBadgeCheck,
  'badge-dollar': faBadgeDollar,
  'ballot-check': faBallotCheck,
  'bell-on': faBellOn,
  'bell-slash': faBellSlash,
  'bullseye-arrow': faBullseyeArrow,
  'calendar-alt': faCalendarAlt,
  'calendar-day': faCalendarDay,
  'caret-circle-down': faCaretCircleDown,
  'caret-circle-up': faCaretCircleUp,
  'chart-simple': faChartSimple,
  'check-circle': faCheckCircle,
  'check-double': faCheckDouble,
  'chevron-down': faChevronDown,
  'chevron-left': faChevronLeft,
  'chevron-right': faChevronRight,
  'chevron-up': faChevronUp,
  'circle-minus': faCircleMinus,
  'cloud-download': faCloudDownload,
  'cloud-upload': faCloudUpload,
  'cloud-upload-alt': faCloudUploadAlt,
  'comment-alt-dollar': faCommentAltDollar,
  'comment-alt-dots': faCommentAltDots,
  'comment-alt-lines': faCommentAltLines,
  'comment-alt-minus': faCommentAltMinus,
  'comment-alt-slash': faCommentAltSlash,
  'comment-alt': faCommentAlt,
  'columns-3': faColumns3,
  'credit-card-blank': faCreditCardBlank,
  'dollar-sign': faDollarSign,
  'dot-circle': faDotCircle,
  'check-circle-sharp-duotone': faCircleCheckSharpDuotone,
  'circle-dot-sharp-duotone': faCircleDotSharpDuotone,
  'exclamation-triangle-sharp-duotone': faTriangleExclamationSharpDuotone,
  'ellipsis-h': faEllipsisH,
  'ellipsis-v': faEllipsisV,
  'envelope-open': faEnvelopeOpen,
  'exclamation-triangle': faExclamationTriangle,
  'external-link-alt': faExternalLinkAlt,
  'eye-slash': faEyeSlash,
  'file-alt': faFileAlt,
  'file-contract': faFileContract,
  'file-export': faFileExport,
  'file-invoice-dollar': faFileInvoiceDollar,
  'file-minus': faFileMinus,
  'file-pdf': faFilePdf,
  'file-plus': faFilePlus,
  'gas-pump': faGasPump,
  'globe-americas': faGlobeAmericas,
  'hand-paper': faHandPaper,
  'hand-pointer': faHandPointer,
  'id-card-alt': faIdCardAlt,
  'industry-alt': faIndustryAlt,
  'info-circle': faInfoCircle,
  'layer-group': faLayerGroup,
  'list-ul': faListUl,
  'location-arrow': faLocationArrow,
  'map-marker': faMapMarker,
  'map-signs': faMapSigns,
  'message-dots': faMessageDots,
  'micro-chip-ai': faMicrochipAi,
  'money-check-alt': faMoneyCheckAlt,
  'money-check-edit-alt': faMoneyCheckEditAlt,
  'paint-brush': faPaintBrush,
  'paper-plane': faPaperPlane,
  'pen-alt': faPenAlt,
  'power-off': faPowerOff,
  'question-circle': faQuestionCircle,
  'quote-left': faQuoteLeft,
  'radiation-alt': faRadiationAlt,
  'ramp-loading': faRampLoading,
  'rectangle-list': faRectangleList,
  'repeat-alt': faRepeatAlt,
  resize: faArrowUpRightAndArrowDownLeftFromCenter,
  'route-interstate': faRouteInterstate,
  'shield-check': faShieldCheck,
  'shipping-fast': faShippingFast,
  'shipping-timed': faShippingTimed,
  'solar-system': faSolarSystem,
  'solid-circle': faCircleSolid,
  'sort-alt': faSortAlt,
  'sort-circle-up': faSortCircleUp,
  'square-arrow-up-right': faSquareArrowUpRight,
  'square-full': faSquareFull,
  'square-minus': faSquareMinus,
  'square-arrow-up': faSquareArrowUp,
  'square-arrow-down': faSquareArrowDown,
  'star-sharp': faStarSharp,
  'step-forward': faStepForward,
  'sticky-note': faStickyNote,
  'store-alt': faStoreAlt,
  'thumbs-up': faThumbsUp,
  'toggle-on': faToggleOn,
  'toilet-paper-under': faToiletPaperUnder,
  'broadcast-tower': faBroadcastTower,
  'trash-restore-alt': faTrashRestoreAlt,
  'trash-xmark': faTrashXmark,
  'truck-moving': faTruckMoving,
  'truck-fast': faTruckFast,
  'truck-ramp-box': faTruckRampBox,
  'usd-circle': faUsdCircle,
  'usd-square': faUsdSquare,
  'user-check': faUserCheck,
  'user-circle': faUserCircle,
  'user-shield': faUserShield,
  'warehouse-alt': faWarehouseAlt,
  'weight-hanging': faWeightHanging,
  'window-minimize': faWindowMinimize,
  analytics: faAnalytics,
  archive: faArchive,
  at: faAt,
  backspace: faBackspace,
  ban: faBan,
  bars: faBars,
  bell: faBell,
  book: faBook,
  box: faBox,
  boxes: faBoxes,
  building: faBuilding,
  calculator: faCalculator,
  calendar: faCalendar,
  check: faCheck,
  circle: faCircle,
  city: faCity,
  clipboard: faClipboard,
  clock: faClock,
  clone: faClone,
  code: faCode,
  cog: faCog,
  crown: faCrown,
  dash: faDash,
  dolly: faDolly,
  donate: faDonate,
  download: faDownload,
  edit: faEdit,
  envelope: faEnvelope,
  envelopes: faEnvelopes,
  eraser: faEraser,
  exchange: faExchange,
  expand: faExpand,
  eye: faEye,
  female: faFemale,
  file: faFile,
  filter: faFilter,
  forklift: faForklift,
  globe: faGlobe,
  hammer: faHammer,
  hashtag: faHashtag,
  history: faHistory,
  home: faHome,
  key: faKey,
  lightbulb: faLightbulb,
  link: faLink,
  list: faList,
  lock: faLock,
  male: faMale,
  marker: faMarker,
  maximize: faMaximize,
  merge: faMerge,
  messages: faMessages,
  minimize: faMinimize,
  minus: faMinus,
  pen: faPen,
  percent: faPercent,
  phone: faPhone,
  plus: faPlus,
  print: faPrint,
  random: faRandom,
  redo: faRedo,
  road: faRoad,
  rocket: faRocketLaunch,
  route: faRoute,
  ruler: faRuler,
  save: faSave,
  search: faSearch,
  server: faServer,
  share: faShare,
  spinner: faSpinner,
  square: faSquare,
  stopwatch: faStopwatch,
  sync: faSync,
  table: faTable,
  tags: faTags,
  tally: faTally,
  thumbtack: faThumbtack,
  'thumbtack-angle': faThumbtackAngle,
  ticket: faTicket,
  times: faTimes,
  trash: faTrash,
  tree: faTree,
  triangle: faTriangle,
  trophy: faTrophy,
  truck: faTruck,
  undo: faUndo,
  upload: faUpload,
  ups: faUps,
  user: faUser,
  users: faUsers,
  warehouse: faWarehouse,
  experiment: faFlask,
  google: faGoogle,
  x: faXmark,
  bug: faBug,
  robot: faUserRobot,
  'pallet-jack': faPalletJack,
  scale: faScaleBalanced,
  'grip-dots': faGripDots,
  unlock: faUnlock,
  'thumbs-down': faThumbsDown,
  'salt-shaker': faSaltShaker,
}

export type IconName = keyof typeof faIcons

export type IconProps = PropsWithClassName<
  Omit<FontAwesomeIconProps, 'icon'> & {
    icon: IconName
    autoWidth?: boolean
  }
>

const FaIcon = memo(FontAwesomeIcon)

const IconRef = forwardRef(
  (
    { icon, autoWidth, className, ...props }: IconProps,
    ref?: ForwardedRef<SVGSVGElement>,
  ) => {
    if (!faIcons[icon]) {
      console.warn(`Icon '${icon}' has not been defined.`)
      icon = 'spinner'
    }

    const faIcon = faIcons[icon] as IconProp

    return (
      <FaIcon
        {...props}
        ref={ref}
        icon={faIcon}
        className={clsx(autoWidth && 'fa-width-auto', className)}
        spin={icon === 'spinner' || icon === 'sync' || props.spin}
      />
    )
  },
)

export const Icon = memo(IconRef)
